import React, { Component } from 'react'
import { connect } from 'react-redux'
import i18next from 'i18next'

import {
  getWopi360TargetDetails,
  sendInvitations,
  deleteInvitation,
  sendReminders
} from '../../ducks/wopi360-target'
import { closeWopi360Target } from '../../ducks/wopi360-targets-admin'

import Wopi360TargetDetails from '../Wopi360TargetDetails'
import Loading from '../Loading'
import GridContainer from '../GridContainer'

import adminStyles from '../styles/admin.scss'

class Wopi360TargetDetailsContainer extends Component {
  componentDidMount() {
    const { getWopi360TargetDetails, params: { uuid } } = this.props

    getWopi360TargetDetails(uuid)
  }

  handleCloseTarget = () => {
    const { closeWopi360Target, params: { uuid } } = this.props

    closeWopi360Target(uuid)
  }

  handleDeleteTargetInvitation = invitationUuid => {
    const { currentOrganisationId, deleteInvitation, params: { uuid } } = this.props

    if (confirm(i18next.t('are_you_sure'))) {
      deleteInvitation(currentOrganisationId, uuid, invitationUuid)
    }
  }

  sendReminderEmails = invitationUuids => {
    const { currentOrganisationId, params: { uuid } } = this.props
    this.props.sendReminders(currentOrganisationId, uuid, invitationUuids)
  }

  render() {
    const {
      wopi360TargetDetails,
      currentLanguage,
      currentAccount,
      sendInvitations,
      sentInvitations,
      deletedInvitations,
      sentReminders
    } = this.props

    return (
      <Loading inline={true} isReady={wopi360TargetDetails}>
        {wopi360TargetDetails && (
          <GridContainer>
            <div className={adminStyles.app}>
              <Wopi360TargetDetails
                wopi360TargetDetails={wopi360TargetDetails}
                currentAccountOption={currentAccount}
                currentLanguage={currentLanguage}
                sentInvitations={sentInvitations}
                deletedInvitations={deletedInvitations}
                onCloseTarget={this.handleCloseTarget}
                onSendInvitations={sendInvitations}
                onDeleteInvitation={this.handleDeleteTargetInvitation}
                onSendReminders={this.sendReminderEmails}
                sentReminders={sentReminders}
              />
            </div>
          </GridContainer>
        )}
      </Loading>
    )
  }
}

export default connect(
  state => ({
    currentLanguage: state.account.get('currentLanguage'),
    currentAccount: state.account.get('currentAccount'),
    wopi360TargetDetails: state.wopi360Target.targetDetails,
    sentInvitations: state.wopi360Target.sentInvitations,
    deletedInvitations: state.wopi360Target.deletedInvitations,
    sentReminders: state.wopi360Target.sentReminders
  }),
  {
    getWopi360TargetDetails,
    closeWopi360Target,
    sendInvitations,
    deleteInvitation,
    sendReminders
  }
)(Wopi360TargetDetailsContainer)



// WEBPACK FOOTER //
// ./src/components/smart/Wopi360TargetDetailsContainer.js